export const translations = {
    en: {
        // Dashboard
        dashboard: "Dashboard",
        patients: "Patients",
        waitingList: "Waiting List",
        externalServices: "External Services",
        services: "Services",
        internalServices: "Internal Services",
        insurance: "Insurance",
        analytics: "Revenue & Analytics",
        inventory: "Inventory",
        settings: "Settings",
        logout: "Logout",
        todayEarnings: "Today's earnings",

        // Patients List
        patientName: "Patient Name",
        patient: "Patient",
        phone: "Phone",
        visitDate: "Visit Date",
        time: "Time",
        age: "Age",
        visitType: "Visit Type",
        receipts: "Receipts",
        actions: "Actions",
        viewPatient: "View Patient",
        noVisits: "No visits found",
        searchPlaceholder: "Search by patient name or phone",

        // External Services
        externalServicesCount: "Ext. Services",
        requests: "requests",

        // Header
        welcome: "Welcome",
        language: "Language",

        // Common
        loading: "Loading...",
        error: "Error",
        success: "Success",
        cancel: "Cancel",
        save: "Save",
        delete: "Delete",
        edit: "Edit",
        add: "Add",
        vitals: "Vitals",
        pulse: "Pulse",
        respiratoryRate: "Respiratory rate",
        oxygenSaturation: "Oxygen saturation",
        recordedAt: "Recorded at",
        recordedBy: "Recorded by",
        notes: "Notes",
        noVitalsRecorded: "No vitals recorded yet",
        noVitalsValues: "No values",
        previousVitalsRecords: "Previous records",

        // Add Prescription dialog
        addPrescription: "Add Prescription",
        prescriptionTemplate: "Prescription template",
        selectPrescriptionTemplateRequired: "Please select a prescription template",
        selectPrescriptionTemplatePlaceholder: "Select prescription template",
        newPrescription: "General prescription",
        physicianTemplate: "Custom prescription - روشته خاصه",
        treatmentProgram: "Program",
        treatmentProgramPlaceholder: "Enter the treatment program",
        printOrientation: "Print orientation",
        landscape: "Landscape",
        portrait: "Portrait",
        complaint: "Complaint",
        complaintPlaceholder: "Enter patient complaint",
        diagnosis: "Diagnosis",
        diagnosisPlaceholder: "Enter diagnosis",
        drugDetails: "Drug details",
        drugNamePlaceholder: "Drug name",
        frequency: "Frequency",
        period: "Duration",
        timing: "Timing",
        addAnotherDrug: "Add another drug",
        suppliesUsed: "Supplies used",
        selectSupplyPlaceholder: "Select supply",
        quantity: "Quantity",
        additionalNotes: "Additional notes",
        additionalNotesPlaceholder: "Any additional notes or instructions",
        savePrescription: "Save prescription",
        saveAndPrintPrescription: "Save and Print",
        prescriptionPrintFailed: "Prescription saved, but it could not be opened for printing",
        receiptSavedSuccess: "Receipt added successfully",
        receiptSaveFailed: "Failed to add receipt",
        receiptSavedInventoryFailed: "Receipt saved but inventory update failed",
        savedPrescriptionTemplates: "Saved prescription templates",
        noSavedPrescriptionTemplates: "No saved templates yet",
        saveAsPrescriptionTemplate: "Save as template",
        prescriptionTemplateNamePlaceholder: "Template name",
        prescriptionTemplateApplied: "Prescription template applied",
        prescriptionTemplateSaved: "Prescription template saved",
        prescriptionTemplateRenamed: "Prescription template renamed",
        prescriptionTemplateUpdated: "Prescription template updated",
        prescriptionTemplateDeleted: "Prescription template deleted",
        prescriptionTemplatesLoadFailed: "Failed to load prescription templates",
        prescriptionTemplateSaveFailed: "Failed to save prescription template",
        prescriptionTemplateDeleteFailed: "Failed to delete prescription template",
        renamePrescriptionTemplate: "Rename template",
        updatePrescriptionTemplate: "Update from current prescription",
        updatePrescriptionTemplateConfirm: "Replace this saved template with the current reusable prescription fields?",
        deletePrescriptionTemplate: "Delete template",
        deletePrescriptionTemplateConfirm: "Delete this saved template? Existing prescriptions will not be affected.",
        nextVisitDate: "Next visit date",
        nextVisitDatePlaceholder: "Optional next visit date",
        selectDate: "Select date",
        fetalAssessment: "Fetal assessment",
        printComplaint: "Print complaint",
        printDiagnosis: "Print diagnosis",
        frequencyOnce: "Once",
        frequencyOnceAsNeeded: "Once as needed",
        frequencyTwice: "Twice",
        frequency3Times: "3 times",
        frequency4Times: "4 times",
        frequencyDaily: "Daily",
        frequencyWeekly: "Weekly",
        periodDaily: "Daily",
        period1Day: "1 day",
        period2Days: "2 days",
        period3Days: "3 days",
        period4Days: "4 days",
        period5Days: "5 days",
        period6Days: "6 days",
        periodWeek: "Week",
        period2Weeks: "2 weeks",
        period3Weeks: "3 weeks",
        periodMonth: "Month",
        periodWeeklyTreatment: "Weekly treatment",
        periodMonthlyTreatment: "Monthly treatment",
        periodEvery6MonthsTreatment: "Treatment every 6 months",
        timingBeforeSleep: "Before sleep",
        timingAfterMeals: "After meals",
        timingBeforeMeals: "Before meals",
        timingDuringMeals: "During meals",
        timingAfterBreakfast: "After breakfast",
        timingAfterLunch: "After lunch",
        timingBeforeDinner: "Before dinner",
        timingAfterDinner: "After dinner",
        addSupply: "Add supply",

        // Drug form (dosage form) - optional
        drugForm: "Dosage Form",
        drugFormTab: "Tab (Tablet)",
        drugFormCapsule: "Capsule",
        drugFormSachets: "Sachets (Powder)",
        drugFormAmp: "Amp (Ampoule / Injection)",
        drugFormPatch: "Patch (Skin Patch)",
        drugFormCream: "Cream",
        drugFormSyrup: "Syrup",
        drugFormGel: "Gel",
        drugFormEyeDrops: "Eye drops",
        drugFormUnderTongue: "Under the tongue",

        drugDoseQty: "Dose amount",
        doseQtyOneTablet: "1",
        doseQtyOneHalf: "1.5",
        doseQtyTwoTablets: "2",
        doseQtyTwoHalf: "2.5",
        doseQtyThreeTablets: "3",
        doseQtyFourTablets: "4",

        medicineDetails: "Medicine details",
        medicineDetailsPlaceholder: "Extra instructions or notes for this drug…",

        // Route of administration - optional
        drugRoute: "How to Take",
        drugRouteIv: "IV · Intravenous (into vein)",
        drugRouteIm: "IM · Intramuscular (injection)",
        drugRouteOral: "Oral (by mouth)",
        drugRouteSpray: "Spray (nasal / throat)",
        drugRouteOintment: "Ointment (apply on skin)",
        drugRouteTopical: "Topical (موضعي)",
        drugRouteSublingual: "Sublingual (under tongue)",
        drugRouteLingual: "Lingual (on tongue)",

        // New duration/period options
        periodMonthly: "Monthly",
        periodDayAfterDay: "Day after day",
        period2TimesWeek: "2 times/week",
        period3TimesWeek: "3 times/week",
        periodGradualTitration: "Gradual titration",

        // Medicines management
        medicines: "Medicines",
        medicinesManagement: "Medicines Management",
        addMedicine: "Add Medicine",
        medicineName: "Medicine Name",
        medicineNamePlaceholder: "Enter medicine name",
        medicineAdded: "Medicine added successfully",
        medicineUpdated: "Medicine updated successfully",
        medicineDeleted: "Medicine deleted successfully",
        medicineAddFailed: "Failed to add medicine",
        medicineUpdateFailed: "Failed to update medicine",
        medicineDeleteFailed: "Failed to delete medicine",
        noMedicines: "No medicines added yet",
        medicineAlreadyExists: "This medicine already exists",
        backToDashboard: "Back to Dashboard",
        editMedicine: "Edit Medicine",
        medicineNameRequired: "Medicine name is required",
        medicineHubImport: "Import from Hub",
        medicineHubTitle: "Medicine Hub",
        medicineHubDesc: "Import a pre-built medicine list from the hub into your medicines.",
        medicineHubSelectSpecialty: "Select specialty",
        medicineHubImportBtn: "Import",
        medicineHubImportSuccess: "Imported {imported} medicine(s). {skipped} already existed.",
        medicineHubEmpty: "No specialties found in the hub yet.",
        medicineHubImportFailed: "Failed to import from hub",

        // Assistant attendance (doctor configures zones; assistants check in/out)
        attendanceTitle: "Assistant attendance",
        doctorAttendanceTitle: "Doctor attendance",
        doctorAttendanceMyStatus: "My attendance today",
        doctorAttendanceInside: "Checked in",
        doctorAttendanceOutside: "Checked out",
        doctorAttendanceLastAction: "Last action",
        doctorAttendanceLocationRequired: "Location is checked against the clinic attendance zone.",
        doctorAttendanceChooseClinic: "Choose one clinic to use doctor attendance.",
        doctorAttendanceSignedIn: "Doctor check-in saved.",
        doctorAttendanceSignedOut: "Doctor check-out saved.",
        doctorAttendanceActionFailed: "Attendance could not be saved.",
        doctorAttendanceLoadFailed: "Doctor attendance could not be loaded.",
        doctorAttendanceReport: "Doctors attendance report",
        doctorAttendanceDoctor: "Doctor",
        doctorAttendanceDoctors: "Doctors",
        doctorAttendanceOpenSessions: "Still checked in",
        doctorAttendanceNoLogs: "No doctor attendance in this period.",
        doctorAttendanceClinicLocation: "Clinic attendance location",
        doctorAttendanceLocationReady: "Location is configured for this clinic.",
        doctorAttendanceLocationMissing: "Set the clinic location before doctors check in.",
        attendanceClinicZones: "Clinic check-in zones",
        attendanceZonesHelp: "This is the clinic's shared physical attendance location for doctors and assistants. Open this page inside the clinic, set the radius, then tap “Use device location & save”.",
        attendanceZoneOwnerOnly: "The clinic owner controls this shared location. Other doctors can view it but cannot change it.",
        attendanceNoClinics: "No clinics linked to this account.",
        attendanceClinic: "Clinic",
        attendanceRadiusM: "Radius (m)",
        attendanceZoneStatus: "Zone (lat, lng)",
        attendanceNoZone: "Not set",
        attendanceUseDeviceLocation: "Use device location & save",
        attendanceConfirmDeleteZone: "Remove geofence for this clinic?",
        attendanceZoneSaved: "Clinic location saved.",
        attendanceZoneDeleted: "Zone removed.",
        attendanceGeoNotSupported: "Geolocation is not supported in this browser.",
        attendanceGeoDenied: "Location permission denied or unavailable.",
        attendanceGeoPermissionDenied: "Location permission was denied. Allow location access in the browser settings and try again.",
        attendanceGeoUnavailable: "Your location is unavailable. Turn on device location and try again.",
        attendanceGeoTimeout: "Getting your location took too long. Make sure location is on and try again.",
        attendanceMissingCheckout: "Missing checkout — needs review",
        attendanceMissingCheckin: "Missing check-in — needs review",
        attendanceMissingCheckinRecorded: "Checkout saved. Missing check-in was flagged for owner review.",
        attendanceCorrectMissingCheckout: "Correct missing checkout",
        attendanceSaveCorrection: "Save correction",
        attendanceOriginalCheckIn: "Original check-in",
        attendanceCorrectedCheckoutTime: "Correct checkout date and time",
        attendanceCorrectionNotePlaceholder: "Reason for the correction (required)",
        attendanceCorrectionAuditHelp: "The correction is saved with the owner account, time, and note for audit purposes.",
        attendanceCorrectionSaved: "Checkout correction saved.",
        attendanceLogsTitle: "Attendance log",
        attendanceFilterClinic: "Filter by clinic",
        attendanceRefreshLogs: "Refresh",
        attendanceAssistant: "Assistant",
        attendanceAction: "Action",
        attendanceSignIn: "Sign in",
        attendanceSignOut: "Sign out",
        attendanceDistanceM: "Distance (m)",
        attendanceSummaryTab: " Summary",
        attendanceRawLogsTab: " Raw Logs",
        attendanceTotalHours: "Total Hours",
        attendanceSessions: "Sessions",
        attendanceDaysWorked: "Days Worked",
        attendanceAvgPerDay: "Avg / Day",
        attendanceSignInTime: "Sign In",
        attendanceSignOutTime: "Sign Out",
        attendanceDuration: "Duration",
        attendanceStillCheckedIn: "Still in",
        attendanceTotalAssistants: "Assistants",
        attendanceSummaryHelp: "Click the ▶ arrow in the first column next to an assistant to open payroll (salary, bonuses, discounts) and the daily attendance breakdown.",
        attendanceNoSessions: "No attendance rows to show yet for this filter.",
        attendancePayrollHint: "Salary / payroll is inside each assistant row — expand the row to set monthly salary, hourly rate, and bonuses or discounts.",
        attendancePayrollNoRowsHint: "Choose a clinic and date range. If the list is still empty, link assistants to this doctor and clinic in the admin portal, or wait until there is at least one check-in/out in the logs.",
        attendanceDate: "Date",
        attendanceSalarySection: "Payroll (selected period)",
        attendanceHoursWorkedLabel: "Hours worked",
        attendanceHourlyRate: "Hourly rate",
        attendanceBaseSalary: "Base pay (hours × rate)",
        attendanceAdjustment: "Bonus / discount",
        attendanceAdjustmentHint: "Bonuses add to pay (positive amounts). Discounts reduce pay (saved as deductions). Use the separate buttons below.",
        attendanceAdjustmentReason: "Reason",
        attendanceAdjustmentReasonPh: "e.g. punctuality bonus, leave deduction…",
        attendanceNetSalary: "Net pay",
        attendancePayrollMonth: "Payroll month",
        attendanceHoursInPayrollMonth: "Hours in this month (for salary)",
        attendanceAdjustmentsTitle: "Bonuses & deductions",
        attendanceAdjustmentsSubtitle: "Add rows with the green or red button, then enter an amount and reason.",
        attendanceLineType: "Type",
        attendanceLineTypeBonus: "Bonus",
        attendanceLineTypeDiscount: "Discount",
        attendanceAddBonus: "Add bonus",
        attendanceAddDiscount: "Add discount",
        attendanceBonusAmountPh: "Extra pay",
        attendanceDiscountAmountPh: "Deduct",
        attendanceBonusReasonPh: "e.g. performance bonus",
        attendanceDiscountReasonPh: "e.g. late arrival, equipment damage",
        attendanceAdjustmentAmount: "Amount",
        attendanceSavePayroll: "Save payroll",
        attendancePayrollSaved: "Payroll saved",
        attendancePayrollNote: "Enter monthly salary and hours/day × working days to get the hourly rate automatically, or leave salary at 0 and type an hourly rate. Bonuses/discounts and contract values are saved on the server for this month. Base pay uses logged hours in this month × the active hourly rate.",
        attendanceContractSection: "Monthly contract → hourly rate",
        attendanceMonthlySalary: "Monthly salary (fixed)",
        attendanceHoursPerDay: "Hours per day",
        attendanceWorkingDays: "Working days (this month)",
        attendanceUseWeekdayCount: "Mon–Fri",
        attendanceExpectedHoursMonth: "Expected hours this month",
        attendanceImpliedHourlyRate: "Hourly rate (from contract)",
        attendanceCurrencyHint: "EGP",
        attendanceHourlyRateManual: "Hourly rate (manual)",
        attendanceManualHourlyHint: "Use when you do not enter a monthly salary. Clear salary above to edit this.",
        payrollStep1Label: "Step 1 — Salary setup",
        payrollLeaveZeroForHourly: "Leave 0 to set an hourly rate instead",
        payrollTotalAdjustments: "Total adjustments",
        attendanceContractIncomplete: "Set working days and hours per day so expected hours > 0, or set monthly salary to 0 and use manual hourly rate.",
        attendanceNeedRateOrContract: "Enter a monthly salary with expected hours, or a manual hourly rate.",
        attendanceContractHoursWarning: "Hours/day × working days must be greater than 0.",
        attendanceNoAdjustmentLines: "No bonuses or discounts yet. Use Add bonus or Add discount.",
        total: "Total",

        // Expenses module
        expenses: "Expenses",
        expensesManagement: "Expenses & Costs",
        addExpense: "Add Expense",
        addVariableExpense: "Add Variable Expense",
        addFixedExpense: "Add Fixed Expense",
        fixedExpenses: "Fixed Expenses",
        variableExpenses: "Variable Expenses",
        manageFixedExpenses: "Manage Fixed Expenses",
        fixedExpenseTemplates: "Fixed Expense Templates",
        addNewTemplate: "Add New Template",
        editTemplate: "Edit Template",
        applyFixedExpenses: "Apply Selected",
        selectTemplatesToApply: "Select the fixed expenses to apply this month",
        templateAdded: "Fixed expense template saved",
        templateUpdated: "Template updated",
        templateDeleted: "Template deleted",
        templateAddFailed: "Failed to save template",
        templatesApplied: "Fixed expenses applied successfully",
        templatesApplyFailed: "Failed to apply fixed expenses",
        noTemplates: "No fixed expense templates yet",
        confirmDeleteTemplate: "Delete this fixed expense template?",
        fixedExpenseTotal: "Fixed Expenses Total",
        editExpense: "Edit Expense",
        expenseTitle: "Title",
        expenseAmount: "Amount",
        expenseCategory: "Category",
        expenseDate: "Date",
        expenseNotes: "Notes",
        expenseRecurring: "Recurring",
        expenseTotalExpenses: "Total Expenses",
        expenseTotalRevenue: "Total Revenue",
        expenseProfit: "Net Profit",
        expenseCategoryBreakdown: "Expenses by Category",
        expenseMonthlyTrend: "Monthly Trend",
        expenseRevenueVsCost: "Revenue vs Cost",
        expenseAdded: "Expense added successfully",
        expenseUpdated: "Expense updated successfully",
        expenseDeleted: "Expense deleted successfully",
        expenseAddFailed: "Failed to add expense",
        expenseUpdateFailed: "Failed to update expense",
        expenseDeleteFailed: "Failed to delete expense",
        noExpenses: "No expenses added yet",
        catElectricity: "Electricity",
        catWater: "Water",
        catRent: "Rent",
        catSalary: "Salaries",
        catSupplies: "Supplies & Items",
        catEquipment: "Equipment",
        catMaintenance: "Maintenance",
        catInternet: "Internet & Phone",
        catInsurance: "Insurance",
        catTaxes: "Taxes & Fees",
        catMarketing: "Marketing",
        catOther: "Other",
        allCategories: "All Categories",
        confirmDeleteExpense: "Are you sure you want to delete this expense?",
        thisMonth: "This Month",
        lastMonth: "Last Month",
        profitPositive: "Profit",
        profitNegative: "Loss",

        // OB/GYN Template
        obgynTemplate: "OB/GYN Template (Obstetrics & Gynecology)",
        infertilityTemplate: "روشته حقن مجهري / inferillity",
        obstetricHistory: "history",
        marriedSince: "Married since",
        gplad: "GPLAD",
        gGravidity: "G",
        pParity: "P",
        lLiving: "L",
        aAbortion: "A",
        dDeaths: "D",
        deliveryType: "Delivery type",
        deliverySince: "Since",
        lmp: "LMP (Last Menstrual Period)",
        edd: "EDD (Expected Delivery Date)",
        obgynMedications: "Medications History",
        pastHistory: "Past history",
        surgicalHistory: "Surgical history",
        husbandDetailsSection: "Husband details",
        husbandName: "Husband name",
        husbandAge: "Husband age",
        husbandJob: "Husband job / occupation",
        husbandResidency: "Residency (husband)",
        familyHistory: "Family history",
        consanguinity: "Consanguinity (relative marriage)",
        bloodGroup: "Blood group",
        bloodTransfusion: "Blood transfusion",
        bloodPressure: "Blood pressure",
        weight: "Weight",
        temperature: "Temperature",
        visitTypeLabel: "Visit type",
        investigations: "Investigations",
        addInvestigation: "Add investigation",
        patientAddress: "Address",
        obgynHistorySaved: "Obstetric history saved",
        obgynHistorySaveFailed: "Failed to save obstetric history",
        gravidity: "Gravidity",
        parity: "Parity",
        living: "Living",
        abortion: "Abortion",
        deaths: "Deaths",
        autoCalculated: "auto",
        deliveryNormal: "Normal",
        deliverySC: "SC (Cesarean)",
        editPrescription: "Edit Prescription",
        updatePrescription: "Update Prescription",
        receiptUpdatedSuccess: "Prescription updated successfully",
        receiptUpdateFailed: "Failed to update prescription",

        // Sidebar navigation
        referralSources: "Referral Sources",
        packages: "Packages",
        insuranceCompanies: "Insurance Companies",
        insuranceReports: "Insurance Reports",

        // Packages Management
        packageName: "Package Name",
        service: "Service",
        sessions: "Sessions",
        totalPriceEGP: "Total Price (EGP)",
        perSessionEGP: "Per Session (EGP)",
        expiry: "Expiry",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        noExpiry: "No expiry",
        createPackage: "Create Package",
        editPackage: "Edit Package",
        packageDescription: "Description (optional)",
        expiryDaysLabel: "Expiration (days, optional)",
        numberOfSessions: "Number of sessions",
        totalPriceLabel: "Total price (EGP)",
        serviceType: "Service type",
        packageNameLabel: "Package name",
        deletePackageConfirm: "Delete this package? (Only allowed if not assigned to any patient)",
        noPackages: "No packages yet. Create a package to sell session bundles at a discounted price.",
        sessionPackagesTitle: "Session packages (e.g. Physiotherapy – 6 sessions at discounted price)",
        packageOffers: "Packages / Offers",
        packageCreated: "Package created",
        packageUpdated: "Package updated",
        packageDeleted: "Package deleted",
        packageDeleteFailed: "Failed to delete package",
        packageSaveFailed: "Failed to save package",
        packageLoadFailed: "Failed to load packages",
        update: "Update",
        create: "Create",

        // Insurance report - package column
        packageRemaining: "Package",
        sessionsUsed: "sessions used",

        // Patient detail page
        patientDetailsHeading: "Patient Details",
        fileIdTag: "File ID",
        createBill: "Create Bill",
        assignPackage: "Assign Package",
        discountButton: "Discount",
        scheduleReminder: "Schedule Reminder",
        notifyAssistant: "Notify Assistant",
        medicalHistoryButton: "Medical History",
        medicalReport: "Medical Report",
        referralLetter: "Referral Letter",
        uploadReport: "Upload Report",
        backToPatientList: "Back to List",
        packageBalance: "Package balance",
        packageRemainingLabel: "Remaining",
        packageStatusLabel: "Status",
        packageExpiresLabel: "Expires",
        complaintDiagnosisHeading: "Complaint & Diagnosis",
        procedure: "Procedure",
        enterProcedurePlaceholder: "Enter procedure...",
        addComplaintDiagnosis: "Add Complaint & Diagnosis",
        editComplaintDiagnosis: "Edit Complaint & Diagnosis",
        noComplaintDiagnosisYet: "No complaint or diagnosis recorded yet",
        reportsAndExaminations: "Reports & Examinations",
        prescriptionHistoryTitle: "Prescription History",
        loadingPatientHistory: "Loading patient history...",
        loadingReports: "Loading reports...",
        loadingReferrals: "Loading referrals...",
        visitChangeType: "Change Type",
        visitRegular: "Regular",
        urgencyNormal: "Normal",
        urgencyUrgent: "Urgent",
        patientColDate: "Date",
        patientColDrugs: "Drugs",
        patientColNotes: "Notes",
        patientColDoctor: "Doctor",
        printReceipt: "Print",
        noDrugsInReceipt: "No drugs",
        assignPackageModalTitle: "Assign Package to Patient",
        selectPackagePlaceholder: "Select a package",
        assignPackageOk: "Assign",
        applyDiscountTitle: "Apply Discount",
        discountAmountLabel: "Discount Amount (EGP)",
        discountReasonOptional: "Reason (optional)",
        applyDiscountButton: "Apply Discount",
        discountAmountRequired: "Enter discount amount",
        discountAmountPositive: "Amount must be greater than 0",
        discountInvalidAmount: "Please enter a valid discount amount",
        discountPatientIdMissing: "Patient ID not found. Please refresh and try again.",
        discountRecordedSuccess: "Discount of {amount} EGP recorded. Assistant notified to refund.",
        discountRecordedWarning: "Discount recorded but assistant was not notified. Please notify manually.",
        discountRecordFailed: "Failed to record discount",
        assignPackageFailed: "Failed to assign package",
        referralLettersSection: "Referral Letters",
        enterComplaintPlaceholder: "Enter complaint...",
        enterDiagnosisPlaceholder: "Enter diagnosis...",
        patientPackageFinished: "Finished",
        patientPackageExpired: "Expired",
        noExternalServicesAssigned: "No external services assigned",
        assignExternalServices: "Assign external services",
        noReferralLettersYet: "No referral letters yet",

        // Owner-only pages
        ownerDoctors: "Manage Doctors",
        ownerRevenue: "Clinic Revenue",
        ownerVisitReports: "Visit Reports",
        patientExportSidebar: "Patient Export",
        patientExportTitle: "Patient Data Export",
        patientExportSubtitle: "Download organized Excel files for all doctors or selected doctors.",
        patientExportRefresh: "Refresh",
        patientExportDoctorScope: "Doctor scope",
        patientExportAllDoctors: "All doctors",
        patientExportSelectDoctors: "Select doctors",
        patientExportDateScope: "Date scope",
        patientExportAllDates: "All dates",
        patientExportDownload: "Download Excel",
        patientExportDoctorsIncluded: "Doctors included",
        patientExportIncludedDoctors: "Included doctors",
        patientExportNoDoctors: "No doctors selected",
        patientExportWorkbookTitle: "Workbook contents",
        patientExportDoctor: "Doctor",
        patientExportSuccess: "Patient export downloaded successfully",
        patientExportFailed: "Failed to export patient data",
        patientExportLoadDoctorsFailed: "Failed to load doctors",
        patientExportMissingClinic: "Clinic ID is missing. Please log in again.",
        patientExportSelectDoctor: "Please select at least one doctor",
        patientExportSelectRange: "Please select a date range",
        addDoctor: "Add Doctor",
        doctorEmail: "Dashboard Email",
        doctorPassword: "Dashboard Password",
        totalRevenue: "Total Clinic Revenue",

        // Specialty Diagram
        diagramDental: "Dental Chart",
        diagramBody: "Body Map",
        diagramNone: "No Diagram",
        diagramTitle: "Specialty Diagram",
        diagramSave: "Save Diagram",
        diagramStatus: "Status",
        diagramNote: "Note",
        statusNormal: "Normal",
        statusProblem: "Problem",
        statusTreated: "Treated",
        statusMissing: "Missing",

        // Voice Notes
        voiceNotesTitle: "Voice Notes",
        voiceNoteRecord: "Record",
        voiceNoteStop: "Stop Recording",
        voiceNoteListening: "Listening...",
        voiceNoteSave: "Save voice note",
        voiceNoteEdit: "Edit",
        voiceNoteDelete: "Delete",
        voiceNoteDeleteConfirm: "Delete this voice note?",
        voiceNoteEmpty: "No voice notes yet. Tap New voice note to record.",
        voiceNoteSaved: "Voice note saved",
        voiceNoteDeleted: "Voice note deleted",
        voiceNoteSaveFailed: "Failed to save voice note",
        voiceNoteDeleteFailed: "Failed to delete voice note",
        voiceNoteNotSupported: "Speech recognition is not supported in this browser. Please use Chrome or Edge.",
        voiceNoteTranscriptPlaceholder: "Your speech will appear here... You can also type or edit.",
        voiceNoteAddNew: "New voice note",
        voiceNoteCancelRecord: "Cancel",
        voiceNoteGptFormatTitle: "How should AI organize this note?",
        voiceNoteGptFormatHint: "Raw speech is in Egyptian Arabic. Pick the layout sent to the AI.",
        voiceNoteFormatConversation: "Conversation",
        voiceNoteFormatConversationDesc: "Doctor / patient lines",
        voiceNoteFormatClinical: "Clinical sections",
        voiceNoteFormatClinicalDesc: "Complaint, details, exam, diagnosis, plan",
        voiceNoteFormatNarrative: "Single paragraph",
        voiceNoteFormatNarrativeDesc: "One flowing note, no fixed headings",
        voiceNoteGptApply: "Apply AI",
        voiceNoteGptSkip: "Keep raw text only",
    },
    ar: {
        // Dashboard
        dashboard: "لوحة التحكم",
        patients: "المرضى",
        waitingList: "قائمة الانتظار",
        externalServices: "الخدمات الخارجية",
        services: "الخدمات",
        internalServices: "الخدمات الداخلية",
        insurance: "التأمين",
        analytics: "الإيرادات والتحليلات",
        inventory: "المخزون",
        settings: "الإعدادات",
        logout: "تسجيل الخروج",
        todayEarnings: "دخل اليوم",

        // Patients List
        patientName: "اسم المريض",
        patient: "المريض",
        phone: "رقم الهاتف",
        visitDate: "تاريخ الزيارة",
        time: "الوقت",
        age: "العمر",
        visitType: "نوع الزيارة",
        receipts: "الروشتات",
        actions: "إجراءات",
        viewPatient: "ملف المريض",
        noVisits: "لا توجد زيارات",
        searchPlaceholder: "بحث باسم المريض أو رقم الهاتف",

        // External Services
        externalServicesCount: "خدمات خارجية",
        requests: "طلبات",

        // Header
        welcome: "مرحباً",
        language: "اللغة",

        // Common
        loading: "جاري التحميل...",
        error: "خطأ",
        success: "تم بنجاح",
        cancel: "إلغاء",
        save: "حفظ",
        delete: "حذف",
        edit: "تعديل",
        add: "إضافة",
        vitals: "العلامات الحيوية",
        pulse: "النبض",
        respiratoryRate: "معدل التنفس",
        oxygenSaturation: "نسبة الأكسجين",
        recordedAt: "وقت التسجيل",
        recordedBy: "سجل بواسطة",
        notes: "ملاحظات",
        noVitalsRecorded: "لا توجد علامات حيوية مسجلة بعد",
        noVitalsValues: "لا توجد قيم",
        previousVitalsRecords: "التسجيلات السابقة",

        // Add Prescription dialog
        addPrescription: "إضافة روشتة",
        prescriptionTemplate: "نموذج روشتة",
        selectPrescriptionTemplateRequired: "الرجاء اختيار نموذج الروشتة",
        selectPrescriptionTemplatePlaceholder: "اختر نموذج روشتة",
        newPrescription: "روشته عامه",
        physicianTemplate: "Custom prescription - روشته خاصه",
        treatmentProgram: "البرنامج",
        treatmentProgramPlaceholder: "أدخل البرنامج العلاجي",
        printOrientation: "اتجاه الطباعة",
        landscape: "أفقي (Landscape)",
        portrait: "رأسي (Portrait)",
        complaint: "الشكوى",
        complaintPlaceholder: "أدخل شكوى المريض",
        diagnosis: "التشخيص",
        diagnosisPlaceholder: "أدخل التشخيص",
        drugDetails: "تفاصيل الأدوية",
        drugNamePlaceholder: "اسم الدواء",
        frequency: "التكرار",
        period: "المدة",
        timing: "توقيت الدواء",
        addAnotherDrug: "إضافة دواء آخر",
        suppliesUsed: "المستلزمات المستخدمة",
        selectSupplyPlaceholder: "اختر مستلزم",
        quantity: "الكمية",
        additionalNotes: "ملاحظات إضافية",
        additionalNotesPlaceholder: "أي ملاحظات أو تعليمات إضافية",
        savePrescription: "حفظ الروشتة",
        saveAndPrintPrescription: "حفظ وطباعة",
        prescriptionPrintFailed: "تم حفظ الروشتة، لكن تعذر فتحها للطباعة",
        receiptSavedSuccess: "تمت إضافة الروشتة بنجاح",
        receiptSaveFailed: "فشل في إضافة الروشتة",
        receiptSavedInventoryFailed: "تم حفظ الروشتة لكن تحديث المخزون فشل",
        savedPrescriptionTemplates: "قوالب الروشتات المحفوظة",
        noSavedPrescriptionTemplates: "لا توجد قوالب محفوظة بعد",
        saveAsPrescriptionTemplate: "حفظ كقالب",
        prescriptionTemplateNamePlaceholder: "اسم القالب",
        prescriptionTemplateApplied: "تم تطبيق قالب الروشتة",
        prescriptionTemplateSaved: "تم حفظ قالب الروشتة",
        prescriptionTemplateRenamed: "تم تغيير اسم قالب الروشتة",
        prescriptionTemplateUpdated: "تم تحديث قالب الروشتة",
        prescriptionTemplateDeleted: "تم حذف قالب الروشتة",
        prescriptionTemplatesLoadFailed: "تعذر تحميل قوالب الروشتات",
        prescriptionTemplateSaveFailed: "تعذر حفظ قالب الروشتة",
        prescriptionTemplateDeleteFailed: "تعذر حذف قالب الروشتة",
        renamePrescriptionTemplate: "تغيير اسم القالب",
        updatePrescriptionTemplate: "تحديث من الروشتة الحالية",
        updatePrescriptionTemplateConfirm: "هل تريد استبدال القالب المحفوظ ببيانات الروشتة الحالية القابلة لإعادة الاستخدام؟",
        deletePrescriptionTemplate: "حذف القالب",
        deletePrescriptionTemplateConfirm: "هل تريد حذف هذا القالب؟ لن تتأثر الروشتات السابقة.",
        nextVisitDate: "موعد الزيارة القادمة",
        nextVisitDatePlaceholder: "موعد الزيارة القادمة اختياري",
        selectDate: "اختر التاريخ",
        fetalAssessment: "تقييم الجنين",
        printComplaint: "طباعة الشكوى",
        printDiagnosis: "طباعة التشخيص",
        frequencyOnce: "مرة واحدة",
        frequencyOnceAsNeeded: "مره واحده عند اللزوم",
        frequencyTwice: "مرتين",
        frequency3Times: "3 مرات",
        frequency4Times: "4 مرات",
        frequencyDaily: "يومياً",
        frequencyWeekly: "أسبوعياً",
        periodDaily: "يوميًا",
        period1Day: "1 يوم",
        period2Days: "2 يوم",
        period3Days: "3 يوم",
        period4Days: "4 يوم",
        period5Days: "5 يوم",
        period6Days: "6 يوم",
        periodWeek: "أسبوع",
        period2Weeks: "أسبوعين",
        period3Weeks: "3 اسابيع",
        periodMonth: "شهر",
        periodWeeklyTreatment: "علاج اسبوعي",
        periodMonthlyTreatment: "علاج شهري",
        periodEvery6MonthsTreatment: "علاج كل 6 اشهر",
        timingBeforeSleep: "قبل النوم",
        timingAfterMeals: "بعد الأكل",
        timingBeforeMeals: "قبل الأكل",
        timingDuringMeals: "وسط الاكل",
        timingAfterBreakfast: "بعد الفطار",
        timingAfterLunch: "بعد الغداء",
        timingBeforeDinner: "قبل العشا",
        timingAfterDinner: "بعد العشاء",
        addSupply: "إضافة مستلزم",

        // Drug form (dosage form) - optional
        drugForm: "شكل الجرعة",
        drugFormTab: "أقراص (Tablet)",
        drugFormCapsule: "كبسولات (Capsule)",
        drugFormSachets: "أكياس / باودر (Sachets)",
        drugFormAmp: "أمبول / حقن (Ampoule)",
        drugFormPatch: "لصقة جلدية (Patch)",
        drugFormCream: "كريم (Cream)",
        drugFormSyrup: "شراب (Syrup)",
        drugFormGel: "جل (Gel)",
        drugFormEyeDrops: "قطرات عين",
        drugFormUnderTongue: "تحت اللسان",

        drugDoseQty: "كمية الجرعة",
        doseQtyOneTablet: "1",
        doseQtyOneHalf: "1.5",
        doseQtyTwoTablets: "2",
        doseQtyTwoHalf: "2.5",
        doseQtyThreeTablets: "3",
        doseQtyFourTablets: "4",

        medicineDetails: "تفاصيل الأدوية",
        medicineDetailsPlaceholder: "تعليمات أو ملاحظات إضافية عن الدواء…",

        // Route of administration - optional
        drugRoute: "طريقة الاستخدام",
        drugRouteIv: "IV · وريدي (في الوريد)",
        drugRouteIm: "IM · عضلي (حقن عضل)",
        drugRouteOral: "فموي (عن طريق الفم)",
        drugRouteSpray: "بخاخ (أنف / حلق)",
        drugRouteOintment: "مرهم (يدهن على الجلد)",
        drugRouteTopical: "موضعي (Topical)",
        drugRouteSublingual: "تحت اللسان",
        drugRouteLingual: "على اللسان",

        // New duration/period options
        periodMonthly: "شهرياً",
        periodDayAfterDay: "يوم بعد يوم",
        period2TimesWeek: "مرتان أسبوعياً",
        period3TimesWeek: "3 مرات أسبوعياً",
        periodGradualTitration: "جرعة تدريجية",

        // Medicines management
        medicines: "الأدوية",
        medicinesManagement: "إدارة الأدوية",
        addMedicine: "إضافة دواء",
        medicineName: "اسم الدواء",
        medicineNamePlaceholder: "أدخل اسم الدواء",
        medicineAdded: "تمت إضافة الدواء بنجاح",
        medicineUpdated: "تم تحديث الدواء بنجاح",
        medicineDeleted: "تم حذف الدواء بنجاح",
        medicineAddFailed: "فشل في إضافة الدواء",
        medicineUpdateFailed: "فشل في تحديث الدواء",
        medicineDeleteFailed: "فشل في حذف الدواء",
        noMedicines: "لا توجد أدوية بعد",
        medicineAlreadyExists: "هذا الدواء موجود بالفعل",
        backToDashboard: "العودة للوحة التحكم",
        editMedicine: "تعديل الدواء",
        medicineNameRequired: "اسم الدواء مطلوب",
        medicineHubImport: "استيراد من المستودع",
        medicineHubTitle: "مستودع الأدوية",
        medicineHubDesc: "استورد قائمة أدوية جاهزة من المستودع إلى قائمتك.",
        medicineHubSelectSpecialty: "اختر التخصص",
        medicineHubImportBtn: "استيراد",
        medicineHubImportSuccess: "تم استيراد {imported} دواء. {skipped} موجود بالفعل.",
        medicineHubEmpty: "لا توجد تخصصات في المستودع بعد.",
        medicineHubImportFailed: "فشل في الاستيراد من المستودع",

        attendanceTitle: "حضور وانصراف المساعدين",
        doctorAttendanceTitle: "حضور وانصراف الأطباء",
        doctorAttendanceMyStatus: "حضوري اليوم",
        doctorAttendanceInside: "تم تسجيل الحضور",
        doctorAttendanceOutside: "تم تسجيل الانصراف",
        doctorAttendanceLastAction: "آخر إجراء",
        doctorAttendanceLocationRequired: "يتم التحقق من موقعك داخل نطاق العيادة.",
        doctorAttendanceChooseClinic: "اختر عيادة واحدة لاستخدام حضور الأطباء.",
        doctorAttendanceSignedIn: "تم تسجيل حضور الطبيب.",
        doctorAttendanceSignedOut: "تم تسجيل انصراف الطبيب.",
        doctorAttendanceActionFailed: "تعذر حفظ الحضور أو الانصراف.",
        doctorAttendanceLoadFailed: "تعذر تحميل حضور الأطباء.",
        doctorAttendanceReport: "تقرير حضور وانصراف الأطباء",
        doctorAttendanceDoctor: "الطبيب",
        doctorAttendanceDoctors: "الأطباء",
        doctorAttendanceOpenSessions: "لم يسجلوا الانصراف",
        doctorAttendanceNoLogs: "لا توجد سجلات حضور أطباء في هذه الفترة.",
        doctorAttendanceClinicLocation: "موقع حضور العيادة",
        doctorAttendanceLocationReady: "تم ضبط موقع الحضور لهذه العيادة.",
        doctorAttendanceLocationMissing: "اضبط موقع العيادة قبل تسجيل حضور الأطباء.",
        attendanceClinicZones: "مناطق تسجيل الحضور للعيادات",
        attendanceZonesHelp: "هذا هو الموقع الفعلي المشترك لحضور الأطباء والمساعدين. افتح الصفحة داخل العيادة، حدّد نصف القطر، ثم اضغط «استخدام موقع الجهاز والحفظ».",
        attendanceZoneOwnerOnly: "صاحب العيادة فقط يمكنه تعديل هذا الموقع المشترك، ويمكن لباقي الأطباء رؤيته دون تغييره.",
        attendanceNoClinics: "لا توجد عيادات مرتبطة بهذا الحساب.",
        attendanceClinic: "العيادة",
        attendanceRadiusM: "نصف القطر (م)",
        attendanceZoneStatus: "المنطقة (خط، طول)",
        attendanceNoZone: "غير مضبوط",
        attendanceUseDeviceLocation: "استخدام موقع الجهاز والحفظ",
        attendanceConfirmDeleteZone: "حذف نطاق هذه العيادة؟",
        attendanceZoneSaved: "تم حفظ موقع العيادة.",
        attendanceZoneDeleted: "تم حذف النطاق.",
        attendanceGeoNotSupported: "المتصفح لا يدعم تحديد الموقع.",
        attendanceGeoDenied: "تم رفض الموقع أو لم يتوفر.",
        attendanceGeoPermissionDenied: "تم رفض إذن الموقع. اسمح للموقع من إعدادات المتصفح ثم حاول مرة أخرى.",
        attendanceGeoUnavailable: "موقع الجهاز غير متاح. فعّل خدمة الموقع ثم حاول مرة أخرى.",
        attendanceGeoTimeout: "استغرق تحديد الموقع وقتًا طويلًا. تأكد من تشغيل الموقع ثم حاول مرة أخرى.",
        attendanceMissingCheckout: "انصراف مفقود — يحتاج مراجعة",
        attendanceMissingCheckin: "حضور مفقود — يحتاج مراجعة",
        attendanceMissingCheckinRecorded: "تم تسجيل الانصراف، وتم إرسال الحضور المفقود لمراجعة صاحب العيادة.",
        attendanceCorrectMissingCheckout: "تصحيح الانصراف المفقود",
        attendanceSaveCorrection: "حفظ التصحيح",
        attendanceOriginalCheckIn: "الحضور الأصلي",
        attendanceCorrectedCheckoutTime: "تاريخ ووقت الانصراف الصحيح",
        attendanceCorrectionNotePlaceholder: "سبب التصحيح (مطلوب)",
        attendanceCorrectionAuditHelp: "يُحفظ التصحيح مع حساب صاحب العيادة ووقت التنفيذ والملاحظة للمراجعة.",
        attendanceCorrectionSaved: "تم حفظ تصحيح الانصراف.",
        attendanceLogsTitle: "سجل الحضور والانصراف",
        attendanceFilterClinic: "تصفية حسب العيادة",
        attendanceRefreshLogs: "تحديث",
        attendanceAssistant: "المساعد",
        attendanceAction: "الإجراء",
        attendanceSignIn: "حضور",
        attendanceSignOut: "انصراف",
        attendanceDistanceM: "المسافة (م)",
        attendanceSummaryTab: " ملخص",
        attendanceRawLogsTab: " السجل التفصيلي",
        attendanceTotalHours: "إجمالي الساعات",
        attendanceSessions: "الجلسات",
        attendanceDaysWorked: "أيام العمل",
        attendanceAvgPerDay: "متوسط / يوم",
        attendanceSignInTime: "وقت الحضور",
        attendanceSignOutTime: "وقت الانصراف",
        attendanceDuration: "المدة",
        attendanceStillCheckedIn: "لم ينصرف",
        attendanceTotalAssistants: "المساعدون",
        attendanceSummaryHelp: "اضغط السهم ▶ في العمود الأول بجانب اسم المساعد لفتح الراتب (الأجر، المكافآت، الخصومات) وتفاصيل الحضور اليومي.",
        attendanceNoSessions: "لا صفوف حضور لهذا التصفية بعد.",
        attendancePayrollHint: "الراتب يظهر داخل صف كل مساعد — افتح الصف لضبط الراتب الشهري وأجر الساعة والمكافآت أو الخصومات.",
        attendancePayrollNoRowsHint: "اختر العيادة والفترة. إن استمرت القائمة فارغة، اربط المساعدين بهذا الطبيب والعيادة من بوابة الإدارة، أو انتظر حتى يظهر تسجيل حضور/انصراف في السجل.",
        attendanceDate: "التاريخ",
        attendanceSalarySection: "الراتب حسب الفترة المحددة",
        attendanceHoursWorkedLabel: "ساعات العمل",
        attendanceHourlyRate: "أجر الساعة",
        attendanceBaseSalary: "الأساس (ساعات × الأجر)",
        attendanceAdjustment: "مكافأة / خصم",
        attendanceAdjustmentHint: "المكافأة تزيد الراتب (مبلغ موجب). الخصم يقلله (يُحفظ كسالب). استخدم الزرين أدناه.",
        attendanceAdjustmentReason: "السبب",
        attendanceAdjustmentReasonPh: "مثال: مكافأة انضباط، خصم بسبب غياب…",
        attendanceNetSalary: "صافي المستحق",
        attendancePayrollMonth: "شهر الراتب",
        attendanceHoursInPayrollMonth: "ساعات هذا الشهر (للراتب)",
        attendanceAdjustmentsTitle: "مكافآت وخصومات",
        attendanceAdjustmentsSubtitle: "أضف سطراً بالزر الأخضر أو الأحمر، ثم أدخل المبلغ والسبب.",
        attendanceLineType: "النوع",
        attendanceLineTypeBonus: "مكافأة",
        attendanceLineTypeDiscount: "خصم",
        attendanceAddBonus: "إضافة مكافأة",
        attendanceAddDiscount: "إضافة خصم",
        attendanceBonusAmountPh: "مبلغ إضافي",
        attendanceDiscountAmountPh: "مبلغ الخصم",
        attendanceBonusReasonPh: "مثال: مكافأة أداء",
        attendanceDiscountReasonPh: "مثال: تأخر، تلف معدات",
        attendanceAdjustmentAmount: "المبلغ",
        attendanceSavePayroll: "حفظ الراتب",
        attendancePayrollSaved: "تم حفظ الراتب",
        attendancePayrollNote: "أدخل الراتب الشهري وساعات اليوم × أيام العمل لحساب أجر الساعة تلقائياً، أو اترك الراتب 0 وأدخل أجر الساعة يدوياً. تُحفظ القيم والمكافآت والخصومات على الخادم لهذا الشهر. الراتب الأساسي = ساعات الحضور × أجر الساعة الفعّال.",
        attendanceContractSection: "عقد شهري ← أجر الساعة",
        attendanceMonthlySalary: "راتب شهري (ثابت)",
        attendanceHoursPerDay: "ساعات العمل يومياً",
        attendanceWorkingDays: "أيام العمل (هذا الشهر)",
        attendanceUseWeekdayCount: "اثنين–جمعة",
        attendanceExpectedHoursMonth: "الساعات المتوقعة هذا الشهر",
        attendanceImpliedHourlyRate: "أجر الساعة (من العقد)",
        attendanceCurrencyHint: "ج.م",
        attendanceHourlyRateManual: "أجر الساعة (يدوي)",
        attendanceManualHourlyHint: "يُستخدم عند عدم إدخال راتب شهري. أخلِ الراتب أعلاه إلى 0 لتعديل هذا.",
        payrollStep1Label: "الخطوة 1 — إعداد الراتب",
        payrollLeaveZeroForHourly: "اترك 0 لإدخال أجر الساعة بدلاً من ذلك",
        payrollTotalAdjustments: "مجموع التعديلات",
        attendanceContractIncomplete: "حدد أيام العمل وساعات اليوم حتى تصبح الساعات المتوقعة أكبر من صفر، أو اجعل الراتب الشهري 0 واستخدم أجر الساعة اليدوي.",
        attendanceNeedRateOrContract: "أدخل راتباً شهرياً مع ساعات متوقعة، أو أجر ساعة يدوي.",
        attendanceContractHoursWarning: "يجب أن يكون حاصل ساعات اليوم × أيام العمل أكبر من صفر.",
        attendanceNoAdjustmentLines: "لا توجد مكافآت أو خصومات. استخدم «إضافة مكافأة» أو «إضافة خصم».",
        total: "الإجمالي",

        // Expenses module
        expenses: "المصروفات",
        expensesManagement: "المصروفات والتكاليف",
        addExpense: "إضافة مصروف",
        addVariableExpense: "إضافة مصروف متغير",
        addFixedExpense: "إضافة مصروف ثابت",
        fixedExpenses: "المصروفات الثابتة",
        variableExpenses: "المصروفات المتغيرة",
        manageFixedExpenses: "إدارة المصروفات الثابتة",
        fixedExpenseTemplates: "قوالب المصروفات الثابتة",
        addNewTemplate: "إضافة قالب جديد",
        editTemplate: "تعديل القالب",
        applyFixedExpenses: "تطبيق المختار",
        selectTemplatesToApply: "اختر المصروفات الثابتة لتطبيقها هذا الشهر",
        templateAdded: "تم حفظ قالب المصروف الثابت",
        templateUpdated: "تم تحديث القالب",
        templateDeleted: "تم حذف القالب",
        templateAddFailed: "فشل في حفظ القالب",
        templatesApplied: "تم تطبيق المصروفات الثابتة بنجاح",
        templatesApplyFailed: "فشل في تطبيق المصروفات الثابتة",
        noTemplates: "لا توجد قوالب مصروفات ثابتة بعد",
        confirmDeleteTemplate: "حذف قالب المصروف الثابت؟",
        fixedExpenseTotal: "إجمالي المصروفات الثابتة",
        editExpense: "تعديل مصروف",
        expenseTitle: "العنوان",
        expenseAmount: "المبلغ",
        expenseCategory: "الفئة",
        expenseDate: "التاريخ",
        expenseNotes: "ملاحظات",
        expenseRecurring: "متكرر",
        expenseTotalExpenses: "إجمالي المصروفات",
        expenseTotalRevenue: "إجمالي الإيرادات",
        expenseProfit: "صافي الربح",
        expenseCategoryBreakdown: "المصروفات حسب الفئة",
        expenseMonthlyTrend: "الاتجاه الشهري",
        expenseRevenueVsCost: "الإيرادات مقابل التكاليف",
        expenseAdded: "تمت إضافة المصروف بنجاح",
        expenseUpdated: "تم تحديث المصروف بنجاح",
        expenseDeleted: "تم حذف المصروف بنجاح",
        expenseAddFailed: "فشل في إضافة المصروف",
        expenseUpdateFailed: "فشل في تحديث المصروف",
        expenseDeleteFailed: "فشل في حذف المصروف",
        noExpenses: "لا توجد مصروفات بعد",
        catElectricity: "الكهرباء",
        catWater: "المياه",
        catRent: "الإيجار",
        catSalary: "الرواتب",
        catSupplies: "المستلزمات والمشتريات",
        catEquipment: "المعدات",
        catMaintenance: "الصيانة",
        catInternet: "الإنترنت والهاتف",
        catInsurance: "التأمين",
        catTaxes: "الضرائب والرسوم",
        catMarketing: "التسويق",
        catOther: "أخرى",
        allCategories: "جميع الفئات",
        confirmDeleteExpense: "هل أنت متأكد من حذف هذا المصروف؟",
        thisMonth: "هذا الشهر",
        lastMonth: "الشهر الماضي",
        profitPositive: "ربح",
        profitNegative: "خسارة",

        // OB/GYN Template
        obgynTemplate: "قالب النسا والتوليد",
        infertilityTemplate: "روشته حقن مجهري / inferillity",
        obstetricHistory: "التاريخ المرضي",
        marriedSince: "متزوجة منذ",
        gplad: "GPLAD",
        gGravidity: "G",
        pParity: "P",
        lLiving: "L",
        aAbortion: "A",
        dDeaths: "D",
        deliveryType: "نوع الولادة",
        deliverySince: "منذ",
        lmp: "LMP تاريخ آخر دورة",
        edd: "EDD تاريخ الولادة المتوقع",
        obgynMedications: "سجل الأدوية",
        pastHistory: "التاريخ المرضي",
        surgicalHistory: "التاريخ الجراحي",
        husbandDetailsSection: "بيانات الزوج",
        husbandName: "اسم الزوج",
        husbandAge: "عمر الزوج",
        husbandJob: "مهنة الزوج",
        husbandResidency: "الإقامة",
        familyHistory: "التاريخ العائلي",
        consanguinity: "زواج أقارب",
        bloodGroup: "فصيلة الدم",
        bloodTransfusion: "نقل الدم",
        bloodPressure: "ضغط الدم",
        weight: "الوزن",
        temperature: "درجة الحرارة",
        visitTypeLabel: "نوع الزيارة",
        investigations: "الفحوصات",
        addInvestigation: "إضافة فحص",
        patientAddress: "العنوان",
        obgynHistorySaved: "تم حفظ التاريخ الطبي",
        obgynHistorySaveFailed: "فشل في حفظ التاريخ الطبي",
        gravidity: "الحمل",
        parity: "الولادة",
        living: "الأحياء",
        abortion: "الإجهاض",
        deaths: "الوفيات",
        autoCalculated: "محسوب تلقائياً",
        deliveryNormal: "طبيعي",
        deliverySC: "قيصري",
        editPrescription: "تعديل الروشتة",
        updatePrescription: "حفظ التعديلات",
        receiptUpdatedSuccess: "تم تعديل الروشتة بنجاح",
        receiptUpdateFailed: "فشل في تعديل الروشتة",

        // Sidebar navigation
        referralSources: "مصادر التعريف",
        packages: "الباقات",
        insuranceCompanies: "شركات التأمين",
        insuranceReports: "تقارير التأمين",

        // Packages Management
        packageName: "اسم الباقة",
        service: "الخدمة",
        sessions: "الجلسات",
        totalPriceEGP: "إجمالي السعر (ج)",
        perSessionEGP: "لكل جلسة (ج)",
        expiry: "انتهاء الصلاحية",
        status: "الحالة",
        active: "نشط",
        inactive: "غير نشط",
        noExpiry: "بدون انتهاء",
        createPackage: "إنشاء باقة",
        editPackage: "تعديل الباقة",
        packageDescription: "الوصف (اختياري)",
        expiryDaysLabel: "انتهاء الصلاحية (أيام، اختياري)",
        numberOfSessions: "عدد الجلسات",
        totalPriceLabel: "إجمالي السعر (ج)",
        serviceType: "نوع الخدمة",
        packageNameLabel: "اسم الباقة",
        deletePackageConfirm: "حذف هذه الباقة؟ (مسموح فقط إذا لم تُسند لمريض)",
        noPackages: "لا توجد باقات بعد. أنشئ باقة لبيع جلسات مجمعة بسعر مخفض.",
        sessionPackagesTitle: "باقات الجلسات (مثلاً: علاج طبيعي – 6 جلسات بسعر مخفض)",
        packageOffers: "الباقات والعروض",
        packageCreated: "تم إنشاء الباقة",
        packageUpdated: "تم تحديث الباقة",
        packageDeleted: "تم حذف الباقة",
        packageDeleteFailed: "فشل في حذف الباقة",
        packageSaveFailed: "فشل في حفظ الباقة",
        packageLoadFailed: "فشل في تحميل الباقات",
        update: "تحديث",
        create: "إنشاء",

        // Insurance report - package column
        packageRemaining: "الباقة",
        sessionsUsed: "جلسات مستخدمة",

        // Patient detail page
        patientDetailsHeading: "تفاصيل المريض",
        fileIdTag: "رقم ملف",
        createBill: "إنشاء فاتورة",
        assignPackage: "تعيين باقة",
        discountButton: "خصم",
        scheduleReminder: "جدولة تذكير",
        notifyAssistant: "إشعار المساعد",
        medicalHistoryButton: "التاريخ الطبي",
        medicalReport: "تقرير طبي",
        referralLetter: "خطاب إحالة",
        uploadReport: "رفع تقرير",
        backToPatientList: "العودة للقائمة",
        packageBalance: "رصيد الباقة",
        packageRemainingLabel: "المتبقي",
        packageStatusLabel: "الحالة",
        packageExpiresLabel: "ينتهي",
        complaintDiagnosisHeading: "الشكوى والتشخيص",
        procedure: "إجراء",
        enterProcedurePlaceholder: "أدخل الإجراء...",
        addComplaintDiagnosis: "إضافة شكوى وتشخيص",
        editComplaintDiagnosis: "تعديل الشكوى والتشخيص",
        noComplaintDiagnosisYet: "لا توجد شكوى أو تشخيص مسجل بعد",
        reportsAndExaminations: "التقارير والفحوصات",
        prescriptionHistoryTitle: "سجل الروشتات",
        loadingPatientHistory: "جاري تحميل سجل المريض...",
        loadingReports: "جاري تحميل التقارير...",
        loadingReferrals: "جاري تحميل الإحالات...",
        visitChangeType: "تغيير النوع",
        visitRegular: "عادي",
        urgencyNormal: "عادي",
        urgencyUrgent: "عاجل",
        patientColDate: "التاريخ",
        patientColDrugs: "الأدوية",
        patientColNotes: "ملاحظات",
        patientColDoctor: "الطبيب",
        printReceipt: "طباعة",
        noDrugsInReceipt: "لا توجد أدوية",
        assignPackageModalTitle: "تعيين باقة للمريض",
        selectPackagePlaceholder: "اختر باقة",
        assignPackageOk: "تعيين",
        applyDiscountTitle: "تطبيق خصم",
        discountAmountLabel: "مبلغ الخصم (ج)",
        discountReasonOptional: "السبب (اختياري)",
        applyDiscountButton: "تطبيق الخصم",
        discountAmountRequired: "أدخل مبلغ الخصم",
        discountAmountPositive: "يجب أن يكون المبلغ أكبر من 0",
        discountInvalidAmount: "يرجى إدخال مبلغ خصم صالح",
        discountPatientIdMissing: "لم يُعثر على رقم المريض. حدّث الصفحة وحاول مرة أخرى.",
        discountRecordedSuccess: "تم تسجيل خصم {amount} ج. تم إشعار المساعد بالاسترداد.",
        discountRecordedWarning: "تم تسجيل الخصم لكن لم يُشعر المساعد. يرجى الإشعار يدوياً.",
        discountRecordFailed: "فشل تسجيل الخصم",
        assignPackageFailed: "فشل تعيين الباقة",
        referralLettersSection: "خطابات الإحالة",
        enterComplaintPlaceholder: "أدخل الشكوى...",
        enterDiagnosisPlaceholder: "أدخل التشخيص...",
        patientPackageFinished: "منتهية",
        patientPackageExpired: "منتهية الصلاحية",
        noExternalServicesAssigned: "لا توجد خدمات خارجية معيّنة",
        assignExternalServices: "تعيين خدمات خارجية",
        noReferralLettersYet: "لا توجد خطابات إحالة بعد",

        // Owner-only pages
        ownerDoctors: "إدارة الأطباء",
        ownerRevenue: "إيرادات العيادة",
        ownerVisitReports: "تقارير الزيارات",
        patientExportSidebar: "تصدير المرضى",
        patientExportTitle: "تصدير بيانات المرضى",
        patientExportSubtitle: "تحميل ملف Excel منظم لكل الأطباء أو أطباء محددين.",
        patientExportRefresh: "تحديث",
        patientExportDoctorScope: "نطاق الأطباء",
        patientExportAllDoctors: "كل الأطباء",
        patientExportSelectDoctors: "اختر الأطباء",
        patientExportDateScope: "نطاق التاريخ",
        patientExportAllDates: "كل التواريخ",
        patientExportDownload: "تحميل Excel",
        patientExportDoctorsIncluded: "الأطباء داخل الملف",
        patientExportIncludedDoctors: "الأطباء المحددون",
        patientExportNoDoctors: "لا يوجد أطباء محددون",
        patientExportWorkbookTitle: "محتويات ملف Excel",
        patientExportDoctor: "الطبيب",
        patientExportSuccess: "تم تحميل ملف المرضى بنجاح",
        patientExportFailed: "فشل تصدير بيانات المرضى",
        patientExportLoadDoctorsFailed: "فشل تحميل الأطباء",
        patientExportMissingClinic: "رقم العيادة غير موجود. برجاء تسجيل الدخول مرة أخرى.",
        patientExportSelectDoctor: "اختر طبيبا واحدا على الأقل",
        patientExportSelectRange: "اختر نطاق التاريخ",
        addDoctor: "إضافة طبيب",
        doctorEmail: "البريد الإلكتروني",
        doctorPassword: "كلمة المرور",
        totalRevenue: "إجمالي إيرادات العيادة",

        // Specialty Diagram
        diagramDental: "مخطط الأسنان",
        diagramBody: "خريطة الجسم",
        diagramNone: "بدون مخطط",
        diagramTitle: "مخطط التخصص",
        diagramSave: "حفظ المخطط",
        diagramStatus: "الحالة",
        diagramNote: "ملاحظة",
        statusNormal: "طبيعي",
        statusProblem: "مشكلة",
        statusTreated: "تم علاجه",
        statusMissing: "مفقود",

        // Voice Notes
        voiceNotesTitle: "الملاحظات الصوتية",
        voiceNoteRecord: "تسجيل",
        voiceNoteStop: "إيقاف التسجيل",
        voiceNoteListening: "جارٍ الاستماع...",
        voiceNoteSave: "حفظ الملاحظة الصوتية",
        voiceNoteEdit: "تعديل",
        voiceNoteDelete: "حذف",
        voiceNoteDeleteConfirm: "هل تريد حذف هذه الملاحظة الصوتية؟",
        voiceNoteEmpty: "لا توجد ملاحظات صوتية بعد. اضغط «ملاحظة صوتية جديدة» للتسجيل.",
        voiceNoteSaved: "تم حفظ الملاحظة الصوتية",
        voiceNoteDeleted: "تم حذف الملاحظة الصوتية",
        voiceNoteSaveFailed: "فشل حفظ الملاحظة الصوتية",
        voiceNoteDeleteFailed: "فشل حذف الملاحظة الصوتية",
        voiceNoteNotSupported: "التعرف على الصوت غير مدعوم في هذا المتصفح. الرجاء استخدام Chrome أو Edge.",
        voiceNoteTranscriptPlaceholder: "سيظهر الكلام هنا... يمكنك أيضاً الكتابة أو التعديل.",
        voiceNoteAddNew: "ملاحظة صوتية جديدة",
        voiceNoteCancelRecord: "إلغاء",
        voiceNoteGptFormatTitle: "بأي شكل تريد تنظيم الملاحظة؟",
        voiceNoteGptFormatHint: "التفريغ بالعامية المصرية. اختر الشكل المرسل للذكاء الاصطناعي.",
        voiceNoteFormatConversation: "حوار",
        voiceNoteFormatConversationDesc: "سطور: الطبيب — / المريض —",
        voiceNoteFormatClinical: "شكوى وتشخيص وتفاصيل",
        voiceNoteFormatClinicalDesc: "عناوين: الشكوى، التفاصيل، الفحص، التشخيص، الخطة",
        voiceNoteFormatNarrative: "نص واحد متصل",
        voiceNoteFormatNarrativeDesc: "ملاحظة متسلسلة بدون عناوين إجبارية",
        voiceNoteGptApply: "تطبيق الذكاء الاصطناعي",
        voiceNoteGptSkip: "الإبقاء على النص الخام فقط",
    }
};

export type Language = 'en' | 'ar';
/** Keys from either locale so `t()` stays type-safe when en/ar stay in sync. */
export type TranslationKey = keyof typeof translations.en | keyof typeof translations.ar;
